import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=d1354de4&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d1354de4')) {
      api.createRecord('d1354de4', component.options)
    } else {
      api.reload('d1354de4', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=d1354de4&", function () {
      api.rerender('d1354de4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2lAPyEWY4MgMa/JS/offershelp.vue"
export default component.exports